import React from "react";
import { CrownProps, RootProps } from "./types";

export const Crown: React.SFC<CrownProps> = ({ fill, stroke, style }) => (
  <svg
    width="30"
    height="23"
    viewBox="0 0 30 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M17.7637 2.00475C15.9555 2.15185 13.871 1.69827 13.0548 1.4531C10.7945 0.864669 8.72261 1.33051 7.96919 1.63698C3.82535 3.10805 1 7.52125 1 12.3022C1 16.127 4.39042 18.4317 6.08562 19.1059C7.02741 19.4124 9.36302 19.7679 11.1712 18.7381C13.4315 17.451 14.75 18.3704 15.8802 19.6576C16.7843 20.6873 18.1404 21.3125 18.7055 21.4964C21.5308 22.048 27.4076 21.6803 28.3117 15.796C29.4418 8.44066 25.4863 4.57911 23.6028 3.29193C21.7192 2.00475 20.024 1.82086 17.7637 2.00475Z"
      fill={fill || "#fff"}
      stroke={stroke || "#A2A9AD"}
      strokeWidth="1.5"
    />
  </svg>
);

// Root always contains the portion as if it attached as a Crown.
export const Root: React.SFC<RootProps> = ({
  hasRootCanal,
  style,
  fill,
  stroke,
}) => (
  <svg
    width="30"
    height="50"
    viewBox="0 0 30 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M7.9912 5.81174C8.14289 8.01896 7.29593 12.2495 6.85349 14.0888L14.4382 31.1947H20.3164V19.9747L19.7476 13.7209C18.357 10.9006 14.8933 4.63456 12.1628 2.13305C8.74967 -0.993831 7.80158 3.05273 7.9912 5.81174Z"
      fill={fill || "#C4D0D5"}
      stroke={stroke || "#A2A9AD"}
      strokeWidth="1.5"
    />
    <path
      d="M5.5 35.5C6 38.5 6 40.8374 6 43H13V49H19V43H28C27.0963 35.2887 28.7001 27.3469 29.0766 22.8363C29.3779 16.4597 26.1899 10.7875 24.5582 8.74844C21.0439 5.41184 14.8059 1.07426 17.9688 10.4167C21.1317 19.7592 18.2826 27.1615 16.4627 29.6949C11.3418 20.9456 7.30032 10.6021 5.91969 6.52404C5.35489 4.29964 2.71913 3.18744 1.77779 6.52404C0.83645 9.86064 0.459914 15.0509 2.34259 21.3534C4.22527 27.6558 4.95147 32.2088 5.5 35.5Z"
      fill={fill || "#F1F4F5"}
      stroke={stroke || "#A2A9AD"}
      strokeWidth="1.5"
    />

    {hasRootCanal && (
      <g transform="translate(3,2.5)">
        <path
          d="M0.999979 0C-1 14 8 35.5 6 37H20.5C24.674 22.8286 18.8261 4.92857 16 0.5C22.5 14 20.9131 27.0476 17 30C13.8695 32.3619 11.2818 30.6255 10.5 30C5.5 26 0.5 12 0.999979 0Z"
          fill="#C270A7"
        />
      </g>
    )}
  </svg>
);
